/**
 * GMA-1747 — demo-instance data banner.
 *
 * commandcenter.compasscare.app is built with REACT_APP_DEMO_DATA=1. The
 * public demo has no session, so useFetch never fires
 * (compass-command-center#31): every alert, client, route and vital on
 * screen is sample data. An authenticated session on the same build can
 * merge live API results with demo records, so the banner must not claim
 * that everything shown is sample-only. This strip must not claim a live
 * FEMA IPAWS feed on that build.
 *
 * Gated on the build flag; renders nothing on a real-data build. `enabled` is
 * injectable for tests.
 */
import React from "react";
import PropTypes from "prop-types";
import { DEMO_DATA_ENABLED } from "../../pages/web/demoData";

export default function DemoDataBanner({ enabled = DEMO_DATA_ENABLED }) {
  if (!enabled) return null;
  return (
    <div
      data-testid="demo-data-banner"
      role="status"
      aria-live="polite"
      style={{
        background: "#B45309",
        color: "#FFF7ED",
        fontSize: 12.5,
        fontWeight: 600,
        lineHeight: 1.35,
        padding: "6px 20px",
        textAlign: "center",
        borderBottom: "1px solid #7C2D12",
      }}
    >
      <strong style={{ letterSpacing: 0.3 }}>DEMO DATA — NOT LIVE OPERATIONS.</strong>{" "}
      <span style={{ fontWeight: 500 }}>
        These screens include sample government alerts, clients, routes and
        vitals; signed-in sessions may also show live records.
      </span>
    </div>
  );
}

DemoDataBanner.propTypes = {
  /** Override the build flag (tests). Defaults to REACT_APP_DEMO_DATA === "1". */
  enabled: PropTypes.bool,
};
